import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: 'History',

  noDataTitle: 'No history yet',
  noDataDescription:
    'There will be a list of all the transactions you’ve made. For now it’s empty until you perform your first action.',
  deposit: 'Deposit now',

  infoDescription: 'Can’t see your history? You may not have taken any action yet.',
});
